import { useEffect, useState } from 'react';
import { LoanApi } from '@apply/api';
import { IBridgeLoanGridRecord } from '@apply/api/src/api/loanApi';
import { ScopedWaitOverlay } from '@apply/components';
import { SectionHeaderBar } from '../../common/components/SectionHeaderBar';
import { applicationInsights } from '../../ApplicationInsights';
import { RepaidLoansGrid } from './components/RepaidLoansGrid/RepaidLoansGrid';

export const BridgeRepaid = () => {
    const [isLoading, set_isLoading] = useState(true);
    const [loans, set_loans] = useState<IBridgeLoanGridRecord[]>();

    useEffect(() => {
        const loadData = async () => {
            try {
                const response = await new LoanApi.LoanApi(applicationInsights).getBridgeRepaidLoans();
                set_loans(response.result);
            } finally {
                set_isLoading(false);
            }
        };

        loadData();
    }, []);

    return (
        <>
            <SectionHeaderBar title={'Repaid'}></SectionHeaderBar>
            <div
                className='main-content'
                style={{ padding: 0 }}
            >
                <div className='scrollable-content no-search'>
                    <RepaidLoansGrid data={loans} />
                </div>
                <ScopedWaitOverlay
                    visible={isLoading}
                    label='Retrieving Repaid Loans...'
                    mode='Admin'
                />
            </div>
        </>
    );
};
